import { Actions, Atom } from "@cirrus/fe-lib"

import { I18nConfig as params } from "./_params.js"
import * as LocalizationModel from "./model/localization.js"
import { LocaleProvider } from "./ui/locale-provider.js"

export const I18nConfig = {
  params,
  domain: params.domain,
  actions: Actions.from(LocalizationModel),
  atom: Atom.from(LocalizationModel),
  effects: LocalizationModel.effects,
  state: { localization: LocalizationModel.selectors },
  ui: { LocaleProvider },
}
